/* import __COLOCATED_TEMPLATE__ from './installation-instructions.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import type SalesforceConfiguration from 'embercom/models/standalone/salesforce-configuration';

export interface Args {
  isComplete: boolean;
  salesforceConfiguration?: SalesforceConfiguration;
  openInstallLink: () => void;
}

interface Signature {
  Args: Args;
  Element: HTMLElement;
}

export default class SalesforceCopilotInstallationInstructions extends Component<Signature> {
  get importedPackageUrl() {
    return this.args.salesforceConfiguration?.buildLightningSetupUrl('ImportedPackage/home');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Deploy::Salesforce::Copilot::InstallationInstructions': typeof SalesforceCopilotInstallationInstructions;
    'standalone/deploy/salesforce/copilot/installation-instructions': typeof SalesforceCopilotInstallationInstructions;
  }
}
